export const sizes = {
  xxxs: "h-5 w-5",
  xs: "h-8 w-8",
  sm: "h-9 w-9",
  md: "h-10 w-10",
};

export const variants = {
  primary:
    "text-chorus-gray-50 bg-chorus-black-300 disabled:text-chorus-gray-600 disabled:bg-chorus-black-100",
  secondary:
    "text-chorus-black-500 bg-chorus-teal-200 disabled:text-chorus-gray-600 disabled:bg-chorus-teal-100",
  tertiary:
    "text-chorus-black-100 bg-chorus-gray-100 disabled:text-chorus-gray-500",
  link: "text-chorus-gray-800 bg-transparent disabled:text-chorus-gray-500",
  white: "text-chorus-black-100 bg-white  disabled:text-chorus-[#94A3B8]",
  black: "bg-chorus-black-100 text-white",
};

export const spinnerVariants = {
  primary: "text-chorus-gray-50",
  secondary: "text-chorus-black-500",
  tertiary: "text-chorus-black-500",
  link: "text-chorus-black-100",
  white: "text-chorus-black-100",
  black: "text-white",
};
